/**
 * Tiny logger that no-ops in production builds and forwards to `console`
 * during development. Use this instead of raw `console.warn/error/log`
 * anywhere in the app so we don't leak debug output to end users.
 *
 * Usage:
 *   import { log } from '../lib/logger';
 *   log.warn('localStorage unavailable', err);
 */
const IS_DEV = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const log = {
  warn:  IS_DEV ? console.warn.bind(console)  : noop,
  error: IS_DEV ? console.error.bind(console) : noop,
  info:  IS_DEV ? console.info.bind(console)  : noop,
  debug: IS_DEV ? console.debug.bind(console) : noop,
};

export default log;
